import React from "react";

const CustomToggleButton = (props) => {

  /**
   * Destructures the necessary properties from the props object.
   * @param {object} props - The props object containing the necessary properties.
   * @returns None
   */
  const { onCheckChange, onClick, checked, id, disabled } = props;

  /**
   * Handles the event when the toggle button is checked or unchecked.
   * Calls the onCheckChange function with the checked value of the toggle button.
   * @param {Event} e - The event object.
   * @returns None
   */
  const onToggleButtonChecked = (e) => {
    if (disabled) return;
    return onCheckChange && onCheckChange(e.target.checked);
  };

  /**
   * Renders a toggle switch component.
   * @param {string} id - The unique identifier for the toggle switch.
   * @param {boolean} checked - The current state of the toggle switch (true for checked, false for unchecked).
   * @param {function} onClick - The function to be called when the toggle switch is clicked.
   * @param {function} onChange - The function to be called when the toggle switch state changes.
   * @returns {JSX.Element} - The rendered toggle switch component.
   */
  return (
    <>
      <div className="form-check form-switch form-switch-md">
        <input
          type="checkbox"
          className="form-check-input"
          id={id}
          checked={checked}
          disabled={Boolean(disabled)}
          onClick={onClick}
          onChange={onToggleButtonChecked}
        />
      </div>
    </>
  );
};
export default CustomToggleButton;
